import React from "react";
import { Table } from "antd";
import {
  TestSessionDto,
  TestSessionStatusDto,
  TestSessionStatusHistoryDto,
  UserDto,
} from "../../autogenerated/models";

interface StatusHistoryTableProps {
  history: TestSessionStatusHistoryDto[];
  user: UserDto;
  session: TestSessionDto;
}

const StatusHistoryTable: React.FC<StatusHistoryTableProps> = ({
  history = [],
  user = {},
  session = {},
}) => {
  const historyColumns = [
    {
      title: "Previous status",
      dataIndex: "previousStatus",
      key: "previousStatus",
      render: (status: TestSessionStatusDto) => <>{status.name}</>,
    },
    {
      title: "New status",
      dataIndex: "newStatus",
      key: "newStatus",
      render: (status: TestSessionStatusDto) => <>{status.name}</>,
    },
    {
      title: "Changed by",
      dataIndex: "changedBy",
      key: "changedBy",
      render: (changedBy: UserDto) => {
        return <>{changedBy?.name}</>;
      },
    },
    {
      title: "Changed at",
      dataIndex: "changedAt",
      key: "changedAt",
      render: (changedAt: string) => {
        var dateObj = new Date(changedAt);
        return <>{dateObj.toLocaleString()}</>;
      },
    },
  ];

  let historyWithDefault = [
    ...history,
    {
      previousStatus: { name: "-" },
      newStatus: { name: "Setup" },
      changedAt: session.createdAt,
      changedBy: user,
    },
  ];

  return (
    <Table
      columns={historyColumns}
      rowKey="id"
      dataSource={historyWithDefault}
      pagination={false}
      size="small"
    />
  );
};

export default StatusHistoryTable;
